import {ARRAYLAYER} from './ArrayLayerTypes'

export const changeArrayLayer = arrayLayer => {
    return {
        type: ARRAYLAYER,
        load: arrayLayer
    }
}
export const selectNewArrayLayer = (arrayLayer) => {

    return (dispatch) => {
        dispatch(changeArrayLayer(arrayLayer))
    }

}